import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FolderCopyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"folder_copy"}/>
}
